module.exports = __webpack_public_path__ + "img/7.523dd862.jpg";